<template>
  <div class="content">
    <h2 style="margin:20px">问答提取-手术</h2>
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="患者手机号: " style="margin-left: 20px">
        <el-input v-model="selectForm.phone" placeholder="请输入" style="width: 250px" clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 75%">
      <el-table
        border
        :data="dataList"
        style="width: 100%; overflow-y: scroll"
        height="calc(100vh - 220px)"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="聊天流水ID" prop="answerNumber" align="center"></el-table-column>
        <el-table-column label="患者openid" prop="openid" align="center"></el-table-column>
        <el-table-column label="患者手机号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone ? scope.row.phone : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提取信息备注" width="250" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p style="text-align: center; max-width: 300px">
                <span style="color: rgb(59, 59, 59); font-weight: 600">
                  {{
                  scope.row.message
                  }}
                </span>
              </p>
              <div
                slot="reference"
                class="name-wrapper addressDetail"
              >{{ scope.row.message ? scope.row.message : "-" }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="提取时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="detailsBtn(scope.row)" type="text">详情</el-button>
            <el-button size="mini" type="text" style="color: red" @click="deleteBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 详情:回复,推荐用药,上传图片 -->
    <el-dialog
      title="详情"
      :visible.sync="detailsVisible"
      :close-on-click-modal="false"
      top="0"
      :fullscreen="true"
    >
      <h3>流水ID:{{ form.answerNumber }}</h3>
      <!-- 1.文字 2.选项 3.图片 4.推荐用药 -->
      <div class="box" ref="box">
        <div v-for="(item, index) in tableData" :key="index">
          <div class="person-one" v-if="item.userRole == 0">
            <div class="message">
              <div style="margin: 0px 0 10px">患者{{ item.phone }} 问：</div>
              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>
              <div v-if="item.msgType == 1">{{ item.message }}</div>
            </div>
            <div style="margin: 10px 0 0px">提问时间： {{ item.createTime }}</div>
          </div>
          <div class="person-two" v-else>
            <div class="message">
              <div style="margin: 0px 0 10px">
                {{ item.userRole == 1 ? "机器人" : "医生" }}
                {{ item.msgType == 4 ? "推荐商品" : "回复" }} ：
              </div>
              <!-- <div v-if="item.msgType == 1 && item.userRole === 2">
                {{ item.message }}
              </div>-->
              <div v-if="item.msgType == 1" style="font-size: 12px; margin: 10px 0 20px">
                <div v-if="typeof item.message.content === 'object'">
                  <div>{{ item.message.title ? item.message.title : "" }}</div>
                  <p style="white-space: pre-line">{{ item.message.content[0] }}</p>
                </div>
                <div v-else>{{ item.message }}</div>
              </div>

              <div v-if="item.msgType == 3">
                <el-image
                  style="width: 60px; max-height: 60px"
                  :src="item.message"
                  :preview-src-list="[item.message]"
                ></el-image>
              </div>

              <div v-if="item.msgType == 2">
                {{ item.message.title }}:
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 12px; margin: 10px 0 20px">
                    {{ item.title }}：
                    {{ item.answer ? item.answer : "暂无回答" }}
                    <div v-if="item.answerImg">
                      <el-image
                        style="width: 60px; max-height: 60px"
                        :src="item.answerImg"
                        :preview-src-list="[item.answerImg]"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.msgType == 4">
                <div v-for="(item, index) in item.message.content" :key="index">
                  <div style="font-size: 15px; margin: 10px 0 10px">{{ item.productName }}</div>
                </div>
              </div>
            </div>
            <div style="margin: 10px 0 0px">时间：{{ item.createTime }}</div>
          </div>
        </div>
        <el-empty description="暂无聊天记录" v-if="tableData.length === 0"></el-empty>
      </div>
      <div class="btnList">
        <!-- <el-button
          type="primary"
          size="small"
          v-waves
          @click="handleAdd"
          style="margin:0 20px 0 0"
          >回复</el-button
        >-->
        <el-button @click="detailsVisible = false">关闭页面</el-button>
      </div>
    </el-dialog>
    <!-- 回复 -->
    <el-dialog title="回复患者" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="内容" required>
          <el-input
            type="textarea"
            clearable
            v-model="dialogForm.message"
            :rows="5"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配医生 -->
    <el-dialog title="分配医生" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="患者提问" :label-width="formLabelWidth">
          <el-input v-model="form.message" auto-complete="off" disabled type="textarea" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="医生列表: " style="margin-left: 20px">
          <el-select v-model="form.adminId" placeholder="请选择">
            <el-option
              v-for="item in doctorList"
              :label="item.message"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="检测结果(请勿输入&特殊字符)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.result"
            auto-complete="off"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  answersExtractSelect,
  selectRecordDetails,
  answersExtractDelete,
  updateRecord
} from "@/services/answers/record.js";
import { selectspuser } from "@/services/system/admin.js";

export default {
  data() {
    return {
      tableData: [],
      roleId: "",
      selectForm: {},
      downloadLoading: false,
      dataList: [],
      orderDetailArr: [],
      loading: true,
      name: "",
      orderNumber: "",
      phone: "",
      userId: "",
      form: {
        logisticsNumber: ""
      },
      dialogForm: {},
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      detailsVisible: false,
      dialogVisible: false,
      isRole: false,
      //1待邮寄 2已邮寄 3已送检 4检测完成
      doctorList: [],
      formLabelWidth: "100px"
    };
  },
  async created() {
    let result = await selectspuser({ roleId: 3 });
    this.doctorList = result;
    if (this.$store.state.supUser.roleId == 3) {
      this.selectForm.adminId = this.$store.state.supUser.id;
      this.roleId = 3;
    }

    this.select();
  },
  methods: {
    select() {
      // 查询提问数据
      answersExtractSelect({
        ...this.selectForm,
        type: 2
      }).then(resp => {
        this.dataList = resp.data;
        this.loading = false;
      });
    },

    selectBtn() {
      this.select();
    },

    // 接单
    handleJiedan(row) {
      updateRecord({
        ...row,
        adminId: this.$store.state.supUser.id,
        phoneAnswer: this.$store.state.supUser.supplier_phone
      }).then(resp => {
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },

    /* 详情 */
    detailsBtn(row) {
      this.form = JSON.parse(JSON.stringify(row));
      selectRecordDetails({ answerNumber: row.answerNumber }).then(res => {
        this.tableData = res.data.map(item => {
          if (
            item.msgType == 2 ||
            item.msgType == 4 ||
            ((item.userRole === 1 || item.userRole === 2) && item.msgType == 1)
          ) {
            try {
              item.message = JSON.parse(item.message);
            } catch (e) {
              item.message = item.message;
            }
          }
          return item;
        });
        this.detailsVisible = true;
      });
    },

    // 分配弹窗
    handleFenpei(row) {
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 提交表单按钮
    updateBtn() {
      // console.log("点击了确认", this.form);
      updateRecord({
        ...this.form
      }).then(resp => {
        if (resp.code == 200) {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.dialogFormVisible = false;
          this.select();
        }
      });
    },

    deleteBtn(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          answersExtractDelete({ id: row.id }).then(resp => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
    },

    save() {
      //必填字段校验
      if (!this.dialogForm.message) {
        this.$message.error("请填写必填字段");
        return;
      }
    },

    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then(excel => {
        const tHeader = [
          "id",
          "提问号",
          "姓名",
          "手机号",
          "收货地址",
          "留言",
          "提问总价",
          "物流单号",
          "提问状态(0未发货 1已发货 2已完成 3退款中 4已退款)",
          "商品明细",
          "提问时间"
        ];
        const filterVal = [
          "id",
          "orderNumber",
          "name",
          "phone",
          "address",
          "odescribe",
          "cost",
          "logisticsNumber",
          "state",
          "productList",
          "createTime"
        ];
        const dataList = JSON.parse(JSON.stringify(this.dataList));
        const list = dataList.map(item => {
          const product = item.productList.map(item2 => {
            return `${item2.productName}(${item2.price}元)X${item2.num}`;
          });
          item.productList = JSON.parse(JSON.stringify(product));
          return {
            ...item,
            productList: item.productList.join(",")
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "提问列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.content {
  margin: 10px auto;
  width: 98%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.addressDetail:hover {
  cursor: pointer;
}

.addressDetail {
  width: 140px;
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

h3 {
  margin: 0 0 20px;
  font-size: 16px;
}

.box {
  padding: 20px;
  margin: 0 auto;
  width: 95%;
  height: calc(100vh - 250px);
  overflow-y: auto;
  line-height: 26px;
}

.message {
  color: 111;
  font-size: 16px;
}

.person-one {
  background: rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.person-two {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(230, 230, 230, 1);
  padding: 20px 30px;
  border-radius: 20px;
  margin: 10px 0;
}

.btnList {
  display: flex;
  margin: 20px auto;
  justify-content: center;
  button {
    margin: 0 10px;
  }
}
</style>
